var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class AspectCss {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get activeTraitsReverseWithCss() {
        return this.aspect.global.aspectActive.activeTraits
            .concat()
            .reverse()
            .filter(at => !!at.reg.css);
    }
    get css() {
        const obj_css = {};
        this.activeTraitsReverseWithCss.forEach((at) => {
            at.attachedCss.cssPairs.forEach(s => {
                if (typeof obj_css[s.k] !== 'undefined') {
                    if (s.append) {
                        obj_css[s.k] = obj_css[s.k] + s.append + s.v; // css transform properties (performance)
                    }
                    if (s.prepend) {
                        obj_css[s.k] = s.v + s.prepend + obj_css[s.k]; // css transform properties (performance)
                    }
                    if (!s.append && !s.prepend) {
                        obj_css[s.k] = s.v;
                    }
                }
                else {
                    if (typeof s.v !== 'undefined') {
                        obj_css[s.k] = s.v;
                    }
                    else {
                        delete obj_css[s.k];
                    }
                }
            });
        });
        return obj_css;
    }
    get styleString() {
        let style = '';
        this.aspect.global.aspectActive.activeTraits
            .filter(at => !!at.reg.style)
            .forEach((at) => {
            style += at.attachedCss.styleString;
        });
        return style;
    }
    get cssPairs() {
        return Object.entries(this.css);
    }
    get cssKVPairs() {
        return this.cssPairs.map(([k, v]) => ({ k, v }));
    }
}
__decorate([
    computed
], AspectCss.prototype, "activeTraitsReverseWithCss", null);
__decorate([
    computed.struct
], AspectCss.prototype, "css", null);
__decorate([
    computed
], AspectCss.prototype, "styleString", null);
